import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {SUPPORT_WIDGET_SRC} from '../config/config';

// Tickchak support widget (2026-10-11) — replaces the Glassix web widget. Same hook name / call site
// so the swap is a small diff. The app keeps its own "תמיכה והדרכה" FAB (SupportComponent), so the
// script is loaded with data-launcher="none" and opened through window.TickchakSupport (glassixChat.ts).
const SCRIPT_ID = 'tickchak-support-script';

const useGlassixWidget = (skip = false) => {
    const account = useSelector((state) => state.account);
    const user = useSelector((state) => state.user);

    useEffect(() => {
        if(skip) return;
        const context = {
            pid: account?.pid || '',
            eid: '',
            name: user?.uid ? `${user?.nameFirst || ''} ${user?.nameLast || ''}`.trim() : '',
            email: user?.uid ? (user?.email || '') : '',
            phone: user?.uid ? (user?.phone || '') : '',
            page: window.location.href,
        };
        if(window.TickchakSupport?.setContext) {
            // already mounted — only refresh the prefill (account / user / URL changed)
            window.TickchakSupport.setContext(context);
            return;
        }
        if(document.getElementById(SCRIPT_ID)) return;
        const script = document.createElement('script');
        script.id = SCRIPT_ID;
        script.src = SUPPORT_WIDGET_SRC;
        script.async = true;
        script.dataset.launcher = 'none';
        Object.entries(context).forEach(([k, v]) => { script.dataset[k] = v == null ? '' : String(v); });
        document.body.appendChild(script);
    }, [account, user, window.location.href, skip]); // Re-run when account, user, or location changes

};

export default useGlassixWidget;
